<template>
    <v-tooltip :bottom="!right" :right="right" color="#333333">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="$attrs"
                v-on="on"
                @click="$emit('click')"
            >
                <slot/>
            </v-btn>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "ButtonTooltip",
    props: {
        tooltip: {
            type: String,
            default: ''
        },
        right: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>

</style>